import moment from "moment-timezone";

export const getTimeZoneLabel = (timeZone) => {
  if (!timeZone) return null;
  const zoned = moment.tz(timeZone);
  const abbr = zoned.format("z");
  const offset = zoned.format("Z");
  const displayName = timeZone.split("/").pop().replace(/_/g, " ");
  return `${displayName} (${abbr}, UTC${offset})`;
};
